module.exports = __webpack_public_path__ + "img/nascimento_divergente.5dec5e39.png";